<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
       <span slot="tab">
        <a-icon type="fullscreen-exit" />
        Centro de costo
       </span>
        <a-card>
          <g-master name="centro_de_costo"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    :beforeSend="master.beforeSend"
                    ref="master"
                    modalWidth="90%"
          >
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Año')" v-bind="fiOptions">
                    <a-select v-decorator="['year', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                      <a-select-option v-for="year_ in years" :key="year_">
                        {{ year_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                    <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                      <a-select-option v-for="month_ in months_name" :key="month_.value">
                        {{ month_.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Periodo')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['period', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="period_request">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="cc"
                              style="width: 100%"
                              :label="$t('Centro de Costo')"
                              :formItemConfig="fiOptions"
                              :selectedObj.sync="centro_cc"
                              :rowKey="'id'"
                              :columns="columnasCentroCosto"
                              :saveValue="'id'"
                              :hasMultipleRows="true"
                              @model="modeloRecibido"
                              :decorator="['id_t_cc', { rules: [{ required: false, message: 'Valor requerido'}] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Porcentaje')">
                    <a-input-number  style="width: 100%;" v-decorator="['cc_percent', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        columnasCentroCosto: [
          {title: 'ID', dataIndex: 'id', sorter: true},
          {title: 'ID CC', dataIndex: 'cc_id', sorter: true},
          {title: 'Nombre CC', dataIndex: 'cc_name', sorter: true},
          {title: 'ID Segmento', dataIndex: 'segment_id', sorter: true},
          {title: 'Nombre Segmento', dataIndex: 'segment_name', sorter: true},
          {title: 'ID Unidad', dataIndex: 'unit_id', sorter: true},
          {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
          {title: 'ID Proyecto', dataIndex: 'prj_id', sorter: true},
          {title: 'Nombre Proyecto', dataIndex: 'prj_name', sorter: true}
        ],
        centro_cc: null,
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          beforeSend: (data) => {
            if (!JsUtils.isEmpty(this.centro_cc)) {
              data.id_cc = this.centro_cc.cc_id
              data.unit_id = this.centro_cc.unit_id
              data.segment_id = this.centro_cc.segment_id
              data.id_prj = this.centro_cc.prj_id
            }
            return data
          },
          endpoint: 'emp_cc',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo', dataIndex: 'h_period', sorter: true},
              {title: 'Porcentaje', dataIndex: 'cc_percent', sorter: true},
              {title: 'Id unidad', dataIndex: 'unit_id', sorter: true},
              {title: 'Unidad', dataIndex: 'nombre_unidad', sorter: true},
              {title: 'Id segmento', dataIndex: 'segment_id', sorter: true},
              {title: 'Segmento', dataIndex: 'nombre_segmento', sorter: true},
              {title: 'Id Centro costo', dataIndex: 'id_cc', sorter: true},
              {title: 'Centro costo', dataIndex: 'nombre_cc', sorter: true},
              {title: 'Id Proyecto', dataIndex: 'id_prj', sorter: true},
              {title: 'Proyecto', dataIndex: 'nombre_prj', sorter: true},
              {title: 'IdTCc', dataIndex: 'id_t_cc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'year'},
            {name: 'month'},
            {name: 'cc_percent'},
            {name: 'id_t_cc'},
            {name: 'period'}
          ]
        }
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      modeloRecibido (value) {
        this.$refs.master.modal.form.setFieldsValue({
          id_t_cc: value
        })
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 4); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/CentroDeCosto.vue